import { render } from "./QuizActivePage.vue?vue&type=template&id=36c46652"
import script from "./QuizActivePage.vue?vue&type=script&lang=js"
export * from "./QuizActivePage.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__